import {
    SET_WORKFLOW_ACTIVE_PRACTICE,
    SET_WORKFLOW_PRACTICES,
    SET_WORKFLOW_PIMS,
    SET_WORKFLOW_ACTIVE_PRACTICE_ID,
    SET_WORKFLOW_FILTER,
    SET_WORKFLOW_STATUS,
} from '../ActionTypes';

const initialState = {
    pimsList: [],
    practiceList: [],
    workflowPractice: {},
    workflowPracticeId: '',
    practiceFilter: '',
    workFlowStatus: {
        loading: false,
        searchingPractices: true,
        editingPractice: false,
        editingRelations: false,
    },
};

const actionHandlers = (state = initialState, action) => {
    switch (action.type) {
        case SET_WORKFLOW_PIMS:
            return {
                ...state,
                pimsList: action.payload,
            };
        case SET_WORKFLOW_FILTER:
            return {
                ...state,
                practiceFilter: action.payload,
            };
        case SET_WORKFLOW_PRACTICES:
            return {
                ...state,
                practiceList: action.payload,
            };
        case SET_WORKFLOW_ACTIVE_PRACTICE:
            return {
                ...state,
                workflowPractice: action.payload,
            };
        case SET_WORKFLOW_ACTIVE_PRACTICE_ID:
            return {
                ...state,
                workflowPracticeId: action.payload,
            };
        case SET_WORKFLOW_STATUS:
            return {
                ...state,
                workFlowStatus: action.payload,
            };
        default:
            return state;
    }
};

export default actionHandlers;
